import { render, staticRenderFns } from "./VehiculoUbicacionHistory.vue?vue&type=template&id=2b8347ed&scoped=true"
import script from "./VehiculoUbicacionHistory.vue?vue&type=script&lang=js"
export * from "./VehiculoUbicacionHistory.vue?vue&type=script&lang=js"
import style0 from "./VehiculoUbicacionHistory.vue?vue&type=style&index=0&id=2b8347ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8347ed",
  null
  
)

export default component.exports